// extracted by mini-css-extract-plugin
export var date = "PressCardBlock-module--date--4ffd4";
export var icon = "PressCardBlock-module--icon--19b39";
export var iconContainer = "PressCardBlock-module--iconContainer--21a80";
export var learnMore = "PressCardBlock-module--learnMore--3c787";
export var pressCard = "PressCardBlock-module--pressCard--68724";
export var pressCardContainer = "PressCardBlock-module--pressCardContainer--5a6bd";
export var pressContent = "PressCardBlock-module--pressContent--e0ec9";
export var pressDate = "PressCardBlock-module--pressDate--d1941";
export var pressImg = "PressCardBlock-module--pressImg--ea3c8";